<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout>
        <v-menu v-model="showMenu" :position-x="posX" :position-y="posY" absolute offset-y>
            <v-list>
                <v-list-tile>
                    <v-dialog v-model="tagForm" width="500">
                        <template v-slot:activator="{ on }">
                            <v-list-tile-content v-on="on">
                                Tags
                            </v-list-tile-content>
                            <v-list-tile-action v-on="on">
                                <v-icon color="green lighten-1">assistant</v-icon>
                            </v-list-tile-action>
                        </template>

                        <DirectoryTagForm v-if="tagForm" :directory="directory" @tag-form-close="tagForm = false"/>
                    </v-dialog>
                </v-list-tile>

                <v-list-tile @click="openRenameModal">
                    <v-list-tile-content>
                        <v-list-tile-title>Renommer</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-icon color="orange lighten-1">edit</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-list-tile @click="deleteDirectory">
                    <v-list-tile-content>
                        <v-list-tile-title>Supprimer</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-icon color="red lighten-1">delete_forever</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-menu>

        <v-dialog v-model="showModal" width="600">
            <v-form ref="form" v-model="formValid" lazy-validation @submit.prevent.stop="validate">
                <v-card>
                    <v-card-title class="display-1 font-weight-light" primary-title>
                        Renommer un répertoire
                    </v-card-title>

                    <v-card-text>
                        <v-text-field ref="inputName" v-model="formInputName" label="Nom" required :rules="formInputNameRules"></v-text-field>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="showModal = false">
                            Annuler
                        </v-btn>
                        <v-btn color="green lighten-2 white--text" :disabled="!formValid" @click="validate">
                            Enregistrer
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-layout>
</template>

<script>
    import {DirectoryService} from "../../services/directory.service";
    import {DIRECTORY_FETCH} from "../../store/actions.type";
    import DirectoryTagForm from "../form/DirectoryTagForm";

    export default {
        name: "DirectoryItemAdminMenu",
        components: {DirectoryTagForm},
        props: {
            directory: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            tagForm: false,
            posX: 0,
            posY: 0,
            formValid: true,
            formInputName: '',
            formInputNameRules: [
                name => !!name || 'Le nom est nécessaire'
            ],
            showModal: false,
            showMenu: false,
        }),
        mounted() {
            this.formInputName = this.directory.name;
        },
        methods: {
            /**
             * Suppression du répertoire, s'il n'y a aucun enfant
             */
            deleteDirectory: function () {
                this.$confirm('Voulez-vous vraiment supprimer ce répertoire ? Il est impossible de supprimer les répertoires qui ne sont pas vides').then(res => {
                    if (res) {
                        DirectoryService.delete(this.directory.slug).then(() => {
                            this.$store.dispatch(DIRECTORY_FETCH, this.$route.params.slug);
                        });
                    }
                });
            },

            /**
             * Ouvre le menu
             */
            open: function(e) {
                this.showMenu = true;
                this.posX = e.clientX;
                this.posY = e.clientY;
            },

            /**
             * Affiche la modal de renommage du répertoire
             */
            openRenameModal() {
                this.showModal = true;
                this.$nextTick(this.$refs.inputName.focus);
            },
            /**
             * RAZ du formulaire
             */
            resetForm() {
                this.formInputName = '';
                this.showModal = false;
                this.formValid = true;
            },
            /**
             * Soumission du formulaire
             */
            validate() {
                if (this.$refs.form.validate()) {
                    this.formValid = false;

                    DirectoryService.rename(this.directory.slug, this.formInputName).then(() => {
                        this.resetForm();
                        this.$store.dispatch(DIRECTORY_FETCH, this.$route.params.slug);
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
